"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStruct = exports.LegalPropsStruct = exports.UserOriginStruct = void 0;
const superstruct_1 = require("superstruct");
const locale_1 = require("./locale");
exports.UserOriginStruct = (0, superstruct_1.object)({
    device: (0, superstruct_1.string)(),
    code: (0, superstruct_1.string)(),
    code2: (0, superstruct_1.string)(),
    code3: (0, superstruct_1.string)(),
    referrer: (0, superstruct_1.string)(),
    app: (0, superstruct_1.string)(),
    type: (0, superstruct_1.string)(),
});
exports.LegalPropsStruct = (0, superstruct_1.object)({
    termsAccepted: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
    privacyPolicyAccepted: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
});
exports.UserStruct = (0, superstruct_1.object)({
    id: (0, superstruct_1.string)(),
    email: (0, superstruct_1.string)(),
    /** @deprecated Use firstName/lastName. Kept for backwards-compat with existing user docs. */
    username: (0, superstruct_1.optional)((0, superstruct_1.nullable)((0, superstruct_1.string)())),
    firstName: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    lastName: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    organization: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    imageFile: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    imageStoragePath: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    streetAddress: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    postalCode: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    referralCode: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    city: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    country: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    vatId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    industry: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    trialPlaceId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    trialSubscriptionId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    stripeCustomerId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    legal: (0, superstruct_1.optional)(exports.LegalPropsStruct),
    language: (0, superstruct_1.optional)(locale_1.LocaleLongStruct),
    origin: (0, superstruct_1.optional)(exports.UserOriginStruct),
    createdAt: (0, superstruct_1.optional)((0, superstruct_1.date)()),
    completeOnboarding: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
});
exports.UserStruct.type = 'User';
exports.LegalPropsStruct.type = 'LegalProps';
exports.UserOriginStruct.type = 'UserOrigin';
//# sourceMappingURL=user.js.map